/**
* Created by vouill on 3/15/18.
*/

<template>
  <div class="value-item">
    <div
      class="img-cover"
      :style="{'background-image':`url(${imgUrl})`}"/>
    <div class="v-title">. {{ value.fields.title }} .</div>
    <div class="v-desc">{{ value.fields.description }}</div>
  </div>
</template>

<style lang="scss" scoped>
.value-item {
  margin: 1em 2em;
  width: 250px;
}
.img-cover {
  height: 150px;
  background-size: cover;
}

.v-title {
  font-size: 18px;
  font-weight: bold;
  font-family: "Roboto Slab", serif;
  padding: 0.5em;
}
.v-desc {
  position: relative;
  min-height: 10em;
  padding: 1em;
  font-size: 15px;
  &:after {
    position: absolute;
    top: 0;
    left: 0;
    height: 1px;
    width: 90%;
    background-color: lightgrey;
    transform: translateX(5%);
    content: "";
  }
}
</style>

<script>
import { getAsset } from "../../../utils/contentful";

export default {
  name: "ValueItem",
  props: { value: Object, includes: Object },
  computed: {
    imgUrl: function() {
      const { value, includes } = this;
      return getAsset(includes, value.fields.coverImg.sys.id).fields.file.url;
    }
  }
};
</script>
